import React from 'react';
import config from '../../config';
import { twitterPageURL } from '../../util/urlHelpers';
import { StaticPage, TopbarContainer } from '../../containers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  ExternalLink,
} from '../../components';
import css from './FaqPage.module.css';

const FaqPage = () => {
  const { siteTwitterHandle, siteFacebookPage } = config;
  const siteTwitterPage = twitterPageURL(siteTwitterHandle);

  // prettier-ignore
  return (
    <StaticPage
      title="FAQ"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'FaqPage',
        description: 'FAQ',
        name: 'FAQ',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>

          <h1 className={css.pageTitle}>FAQ</h1>
          
          <p>
            <strong>How does Host4Ukraine work?</strong><br/>
            To learn how Host4Ukraine works, please <a href='/how-it-works'>click here</a> to check out our page “How it Works”. 
          </p>

          <p>
            <strong>How do I create a listing?</strong><br/>
            To create a new listing, you first need to set up an account. Once you’re signed up, you just need to select the button „+create new listing“ in the upper right corner or menu of the website and you can start creating your listing right away.
          </p>
           

           <p>
             <strong>How do I close my listing?</strong><br/>
             If you have found a helper or refugee and no longer want your listing to be shown to the public, you need to go to the menu and select “my listings”. Click the button “close listing” in the top right corner of the image of the listing, that you want to close.
              <br/>  <br/>
              If you later on want to re-open the listing, you can always do so by clicking on the button “open listing” in the “my listings” section.
           </p>

           <p>
             <strong>What does the blue „verified“ symbol stand for?</strong><br/>
             The blue “verified” symbol indicates, that the person or organization behind the user account verified their identity. In case of an organization, the verification happens by collecting certain official documentation. In case of a private user, this happens through the verification procedure of our partner “Veriff”, which is one of the world’s leading online verification providers and works closely together with multinational corporations such as banks or insurances from all around the world. 
             <br/>  <br/>
             During the verification process, users upload a live-selfie-photo as well as images of their identity document (e.g. passport, ID card, driver’s license), which will then be verified. The process takes less then 2 minutes. 
              <br/>
              The verified label does not guarantee the legitimacy of the listing. Everyone is still responsible for his own safety. Hence, we encourage everyone to take his own precautions. 
           </p>

           <p>
             <strong>Why do I have to verify my identity?</strong><br/>
             By verifying your identity, you contribute to ensure a safer platform for both refugees and helpers. Furthermore, it adds trustworthiness to your account and increases the chances to find a match.
             <br/>  <br/>
             We recommend you to verify your identity through our verification partner “Veriff”. This will increase the trustworthiness of your user profile and the chances that helpers/refugees reach out to you. Furthermore, we recommend to primarily accept help from verified users. You can recognize a verified user profile by the blue “verified” label next to the respective username. Being in contact with a user, who is not verified, we recommend to ask him to verify himself. It takes under 2 minutes and only requires a live-photo and an official document (e.g. passport, ID card, driver’s license). To start the verification process, you can go to your user profile settings and click on the button “Validate your identity”.
           </p>

           <p>
             <strong>How do I verify myself?</strong><br/>
             To verify yourself, you need to log in to your Host4Ukraine account, select the profile settings and click on „validate my identity“. In case of an organization, you are asked to provide us with certain official documentation. In case of a private account, you’ll have to fill in your name. Subsequently, a pop-up window opens, which leads you through the verification process. 
           </p>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default FaqPage;
